import React from 'react';
import { styled } from "@mui/material/styles";
import { FormControlLabel, Switch, alpha } from '@mui/material';

const GoldenSwitch = (props) => {

  const CustomGoldenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#D3AF5F',
      '&:hover': {
        backgroundColor: alpha('#D3AF5F', theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#D3AF5F',
    },
  }));

  return (
    <FormControlLabel
      className={props.className}
      sx={{marginRight: props.disableMarginRight ? '0' : '16px'}}
      control={<CustomGoldenSwitch
        checked={props.checked}
        onChange={props.onChange}
        size={props.size || "medium"}
      />}
      disabled={props.disabled || false}
      label={props.label}
    />
  )
}

export default GoldenSwitch